"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KSVStanding = void 0;
class KSVStanding {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.id = (_a = data.id) !== null && _a !== void 0 ? _a : null;
        this.position = (_b = data.smbStandingPosition) !== null && _b !== void 0 ? _b : null;
        this.points = (_c = data.smbPoints) !== null && _c !== void 0 ? _c : null;
        this.played = data.smbPlayed;
        this.lost = (_d = data.smbLost) !== null && _d !== void 0 ? _d : null;
        this.won = (_e = data.smbWon) !== null && _e !== void 0 ? _e : null;
        this.draw = (_f = data.smbDrawn) !== null && _f !== void 0 ? _f : null;
        this.goalsAgainst = (_g = data.smbAgainst) !== null && _g !== void 0 ? _g : null;
        this.goalsFor = (_h = data.smbFor) !== null && _h !== void 0 ? _h : null;
        this.goalsDif = this.goalsFor - this.goalsAgainst;
        this.name = (_j = data.smbClub.smbNameFull) !== null && _j !== void 0 ? _j : null;
        this.nameShort = (_k = data.smbClub.smbNameShort) !== null && _k !== void 0 ? _k : null;
        this.logo = (_l = data.smbClub.smbLogo) !== null && _l !== void 0 ? _l : null;
    }
    static fromData(data) {
        return new KSVStanding(Object.assign({}, data));
    }
}
exports.KSVStanding = KSVStanding;
